import { useState } from 'react';
import { message } from 'antd';
import { useProjectApi } from '../api/projects/projects';

/**
 * Gère le like d’un projet avec mise à jour optimiste.
 * @param projectId        ID du projet
 * @param initialLiked     Statut initial (true si l’utilisateur avait déjà liké)
 * @param initialCount     Nombre de likes initial
 */
export function useLike(
    projectId: number,
    initiallyLiked: boolean,
    initialCount: number
) {
    const { toggleLike } = useProjectApi();
    const [liked, setLiked] = useState(initiallyLiked);
    const [count, setCount] = useState(initialCount);

    const toggle = async () => {
        // MAJ optimiste
        setLiked(prev => !prev);
        setCount(prev => (prev + (liked ? -1 : 1)));

        try {
            const { data } = await toggleLike(projectId);
            // backend peut renvoyer { count: N } ou juste N
            if (data) {
                setLiked(data.liked);
                setCount(data.count);
            }

        } catch (err: any) {
            // rollback
            setLiked(prev => !prev);
            setCount(prev => (prev + (liked ? 1 : -1)));
            message.error(err.message || 'Erreur like');
        }
    };

    return { liked, count, toggle };
}
